<!-- Vertical Menu -->
<ng-container>
  <vertical-menu></vertical-menu>
</ng-container>
<!--/ Vertical Menu -->
